export default __webpack_public_path__ + "static/media/Intimation of Board Meeting Q3 FY 25-26.8b88c04f.pdf";